import Modal from 'components/v2/Modal'
import { ReactElement } from 'react'
import { Button } from 'components/v2/Button'
import Heading from 'components/v2/Heading'
import { ErrorMessage } from 'components/v2/ErrorMessage'
import { FormattedMessage } from 'react-intl'
import { getUnprocessableErrors } from 'utils/error'
import { ApolloError } from '@apollo/client'
import styled from 'styled-components'

const ModalDescription = styled.div`
  text-align: center;
`

interface ISpreadKreditsModalProps {
  error?: ApolloError
  clientId: string
  onClose: () => void
  loading: boolean
  onSubmit: () => void
}
const SpreadKreditsModal = ({
  error,
  clientId,
  onClose,
  loading,
  onSubmit
}: ISpreadKreditsModalProps): ReactElement => {
  return (
    <Modal.Container>
      <Modal.Header>
        <Heading.H5>
          <FormattedMessage id="kreditsSpread.title" defaultMessage="Credits Spread" />
        </Heading.H5>
      </Modal.Header>
      <Modal.Content>
        <ModalDescription>
          <FormattedMessage
            id="kreditsSpread.description"
            defaultMessage="Are you sure you want to spread credits to <strong></strong>?"
            values={{
              strong: () => <strong>{clientId.slice(0, 8).toLocaleUpperCase()}</strong>
            }}
          />
        </ModalDescription>
      </Modal.Content>
      <Modal.Footer>
        {error && (
          <Modal.ErrorMessage>
            <ErrorMessage errors={getUnprocessableErrors(error)}>
              <FormattedMessage
                id="kreditsSpread.error"
                defaultMessage="There was an error while spreading the credits."
              />
            </ErrorMessage>
          </Modal.ErrorMessage>
        )}
        <Modal.Actions>
          <Button kind="cancel" onClick={(): void => onClose()}>
            <FormattedMessage id="modal.actions.close" defaultMessage="Back" />
          </Button>
          <Button kind="primary" loading={loading} onClick={onSubmit}>
            <FormattedMessage id="kreditsSpread.cancel.action" defaultMessage="Spread" />
          </Button>
        </Modal.Actions>
      </Modal.Footer>
    </Modal.Container>
  )
}

export default SpreadKreditsModal
